import {useNavigate} from "react-router-dom";
import {HiveBackWrapper} from "features/hive/ui/HiveBack/styles.ts";
import {ArrowToLeftIcon} from "shared/ui/icons";

export const HiveBack = () => {
    const navigate = useNavigate();
    return (
        <HiveBackWrapper onClick={() => navigate('/hives')}>
            <ArrowToLeftIcon/>
            Все ульи
        </HiveBackWrapper>
    );
};

